// @ts-nocheck
/* eslint-disable */
export class TypeTransformationUtils {
    static __static_initialize() {
        if (!TypeTransformationUtils.__static_initialized) {
            TypeTransformationUtils.__static_initialized = true;
            TypeTransformationUtils.__static_initializer_0();
        }
    }
    static conversionMap_$LI$() {
        TypeTransformationUtils.__static_initialize();
        return TypeTransformationUtils.conversionMap;
    }
    static valueIdMap_$LI$() {
        TypeTransformationUtils.__static_initialize();
        return TypeTransformationUtils.valueIdMap;
    }
    static __static_initializer_0() {
        let m = {};
        /* put */ m['Audi'] = '744';
        /* put */ m['BMW'] = '749';
        /* put */ m['Buick'] = '750';
        /* put */ m['Cadillac'] = '752';
        /* put */ m['Chevrolet'] = '753';
        /* put */ m['Chrysler'] = '754';
        /* put */ m['Citroen'] = '757';
        /* put */ m['Daewoo'] = '760';
        /* put */ m['Daihatsu'] = '762';
        /* put */ m['Dodge'] = '764';
        /* put */ m['Fiat'] = '766';
        /* put */ m['Ford'] = '767';
        /* put */ m['Honda'] = '771';
        /* put */ m['Hyundai'] = '772';
        /* put */ m['Jensen'] = '774';
        /* put */ m['Jaguar'] = '775';
        /* put */ m['Jeep'] = '776';
        /* put */ m['Kia'] = '777';
        /* put */ m['Lada'] = '779';
        /* put */ m['Lancia'] = '780';
        /* put */ m['Land Rover'] = '781';
        /* put */ m['Lexus'] = '782';
        /* put */ m['Mazda'] = '784';
        /* put */ m['Mercedes-Benz'] = '785';
        /* put */ m['MG'] = '786';
        /* put */ m['Mitsubishi'] = '787';
        /* put */ m['Morgan'] = '788';
        /* put */ m['Morris'] = '789';
        /* put */ m['Nissan'] = '792';
        /* put */ m['Oldsmobile'] = '794';
        /* put */ m['Opel'] = '795';
        /* put */ m['Peugeot'] = '796';
        /* put */ m['Plymouth'] = '797';
        /* put */ m['Pontiac'] = '800';
        /* put */ m['Porsche'] = '801';
        /* put */ m['Renault'] = '804';
        /* put */ m['Rover'] = '805';
        /* put */ m['Saab'] = '806';
        /* put */ m['Seat'] = '807';
        /* put */ m['Skoda'] = '808';
        /* put */ m['Subaru'] = '810';
        /* put */ m['Suzuki'] = '811';
        /* put */ m['Toyota'] = '813';
        /* put */ m['Triumph'] = '814';
        /* put */ m['Volkswagen'] = '817';
        /* put */ m['Volvo'] = '818';
        /* put */ m['TVR'] = '820';
        /* put */ m['Scion'] = '822';
        /* put */ m['Andre'] = '2252';
        /* put */ m['Ferrari'] = '2999';
        /* put */ m['Maserati'] = '3001';
        /* put */ m['Alfa Romeo'] = '3233';
        /* put */ m['Lamborghini'] = '6731';
        /* put */ m['Aston Martin'] = '6733';
        /* put */ m['Think'] = '6734';
        /* put */ m['Smart'] = '7137';
        /* put */ m['MINI'] = '7147';
        /* put */ m['Lincoln'] = '7153';
        /* put */ m['Bentley'] = '7166';
        /* put */ m['Rolls Royce'] = '7170';
        /* put */ m['Isuzu'] = '7179';
        /* put */ m['Ssangyong'] = '7190';
        /* put */ m['Lotus'] = '7191';
        /* put */ m['Iveco'] = '7280';
        /* put */ m['GMC'] = '7547';
        /* put */ m['Mercury'] = '7554';
        /* put */ m['Hummer'] = '7672';
        /* put */ m['Kewet'] = '7764';
        /* put */ m['Santana'] = '8064';
        /* put */ m['Infiniti'] = '8065';
        /* put */ m['Buddy'] = '8066';
        /* put */ m['De Tomaso'] = '8069';
        /* put */ m['Matra'] = '8070';
        /* put */ m['Reva'] = '8072';
        /* put */ m['Fisker'] = '8073';
        /* put */ m['Austin'] = '8076';
        /* put */ m['Packard'] = '8077';
        /* put */ m['Tesla'] = '8078';
        /* put */ m['Dacia'] = '8079';
        /* put */ m['Tazzari'] = '8080';
        /* put */ m['Koenigsegg'] = '8081';
        /* put */ m['Maybach'] = '8082';
        /* put */ m['mia electric'] = '8083';
        /* put */ m['Piaggio'] = '8084';
        /* put */ m['DeLorean'] = '8085';
        /* put */ m['Wiesmann'] = '8086';
        /* put */ m['McLaren'] = '8087';
        /* put */ m['Radical'] = '8088';
        /* put */ m['Datsun'] = '8089';
        /* put */ m['DAF'] = '8090';
        /* put */ m['DS'] = '8091';
        /* put */ m['Alpina'] = '8092';
        /* put */ m['Abarth'] = '8093';
        /* put */ m['ZD'] = '8094';
        /* put */ m['City-Spirit'] = '8095';
        /* put */ m['Maxus'] = '8096';
        /* put */ m['Bensin'] = '0_1';
        /* put */ m['Diesel'] = '0_2';
        /* put */ m['Gass'] = '0_3';
        /* put */ m['Elektrisitet'] = '0_4';
        /* put */ m['Gass+bensin'] = '0_5';
        /* put */ m['Elektrisitet+bensin'] = '0_6';
        /* put */ m['Gass+diesel'] = '0_7';
        /* put */ m['Elektrisitet+diesel'] = '0_8';
        /* put */ m['Hydrogen'] = '0_9';
        /* put */ m['P\ufffd\ufffd fjellet'] = '1';
        /* put */ m['Ved sj\ufffd\ufffden'] = '2';
        /* put */ m['Innlandet'] = '3';
        /* put */ m['Hage, oppussing og hus'] = '67';
        /* put */ m['Foreldre og barn'] = '68';
        /* put */ m['Sport og friluftsliv'] = '69';
        /* put */ m['Kl\ufffd\ufffdr, kosmetikk og tilbeh\ufffd\ufffdr'] = '71';
        /* put */ m['Antikviteter og kunst'] = '76';
        /* put */ m['Dyr og utstyr'] = '77';
        /* put */ m['M\ufffd\ufffdbler og interi\ufffd\ufffdr'] = '78';
        /* put */ m['Fritid, hobby og underholdning'] = '86';
        /* put */ m['Utstyr til bil, b\ufffd\ufffdt og MC'] = '90';
        /* put */ m['N\ufffd\ufffdringsvirksomhet'] = '91';
        /* put */ m['Elektronikk og hvitevarer'] = '93';
        /* put */ m['Julegave\ufffd\ufffdnsker'] = '94';
        /* put */ m['MC-deler'] = '20';
        /* put */ m['B\ufffd\ufffdtdeler'] = '30';
        /* put */ m['Caravandeler'] = '70';
        /* put */ m['Tilhengere'] = '80';
        /* put */ m['Bildeler'] = '82';
        /* put */ m['Musikkinstrumenter'] = '92';
        /* put */ m['Julegave\ufffd\ufffdnsker'] = '93';
        /* put */ m['Samleobjekter'] = '285';
        /* put */ m['Verksted, bygg og anlegg'] = '3102';
        /* put */ m['Storkj\ufffd\ufffdkken og restaurant'] = '3103';
        /* put */ m['Kontorutstyr og innredning'] = '3105';
        /* put */ m['Webdomener og gullnummer'] = '3106';
        /* put */ m['Butikk og varehandel'] = '3108';
        /* put */ m['Scene'] = '3110';
        /* put */ m['Container og brakker'] = '3111';
        /* put */ m['Maskinutstyr og reservedeler'] = '3112';
        /* put */ m['Last og transport'] = '3113';
        /* put */ m['Landbruk'] = '3114';
        /* put */ m['Resirkulering og returavfall'] = '3115';
        /* put */ m['Data'] = '3215';
        /* put */ m['Husholdningsapparater'] = '3216';
        /* put */ m['Telefoner og tilbeh\ufffd\ufffdr'] = '3217';
        /* put */ m['Byggevarer og oppussing'] = '3899';
        /* put */ m['Kj\ufffd\ufffdkkeninnredning'] = '3900';
        /* put */ m['Hage og uteomr\ufffd\ufffdder'] = '3901';
        /* put */ m['Foto og video'] = '3904';
        /* put */ m['Spill og konsoll'] = '3905';
        /* put */ m['Lyd og bilde'] = '3906';
        /* put */ m['Hvitevarer'] = '3907';
        /* put */ m['Barneseter'] = '3911';
        /* put */ m['Leker'] = '3912';
        /* put */ m['Barnekl\ufffd\ufffdr'] = '3913';
        /* put */ m['Barnevogner'] = '3914';
        /* put */ m['Barnesko'] = '3915';
        /* put */ m['Barnem\ufffd\ufffdbler'] = '3916';
        /* put */ m['Utstyr og sikkerhet'] = '3918';
        /* put */ m['Musikk og film'] = '3922';
        /* put */ m['Supporterutstyr'] = '3937';
        /* put */ m['Ekstremsport'] = '3938';
        /* put */ m['Sportskl\ufffd\ufffdr og sko'] = '3940';
        /* put */ m['Damekl\ufffd\ufffdr'] = '3941';
        /* put */ m['Klokker og ur'] = '3945';
        /* put */ m['Vesker og bager'] = '3946';
        /* put */ m['Mammakl\ufffd\ufffdr'] = '3948';
        /* put */ m['Sko'] = '3949';
        /* put */ m['Herrekl\ufffd\ufffdr'] = '3950';
        /* put */ m['Startnummer'] = '3960';
        /* put */ m['Ballsport'] = '3961';
        /* put */ m['Skisport'] = '3962';
        /* put */ m['Sykkelsport'] = '3963';
        /* put */ m['Jakt, fiske og friluftsliv'] = '3964';
        /* put */ m['Sportsskyting'] = '3965';
        /* put */ m['Annen sport'] = '3966';
        /* put */ m['GPS og pulsklokker'] = '3967';
        /* put */ m['Hytteutstyr'] = '3968';
        /* put */ m['Mat og drikke'] = '3972';
        /* put */ m['ATV-deler'] = '3975';
        /* put */ m['Akvarier'] = '3976';
        /* put */ m['Bur'] = '3977';
        /* put */ m['Golf'] = '5164';
        /* put */ m['Treningsapparater og -utstyr'] = '5166';
        /* put */ m['Andre antikviteter'] = '5175';
        /* put */ m['Keramikk, porselen og glass'] = '5176';
        /* put */ m['Kunst'] = '5177';
        /* put */ m['Antikke m\ufffd\ufffdbler'] = '5178';
        /* put */ m['S\ufffd\ufffdlvt\ufffd\ufffdy og bestikk'] = '5179';
        /* put */ m['Tepper og tekstiler'] = '5180';
        /* put */ m['Belysning'] = '5181';
        /* put */ m['Andre dyr'] = '5183';
        /* put */ m['Annet dyreutstyr'] = '5185';
        /* put */ m['F\ufffd\ufffdrverter, dyrepass, avl og stallplasser'] =
            '5186';
        /* put */ m['Hester'] = '5190';
        /* put */ m['Katter'] = '5191';
        /* put */ m['Hunder'] = '5192';
        /* put */ m['Hundeutstyr'] = '5193';
        /* put */ m['Katteutstyr'] = '5194';
        /* put */ m['Heste- og rideutstyr'] = '5195';
        /* put */ m['Bord og stoler'] = '5196';
        /* put */ m['Senger og madrasser'] = '5197';
        /* put */ m['Garderobe og skap'] = '5198';
        /* put */ m['Brettspill og bordspill'] = '5203';
        /* put */ m['Fugler'] = '5205';
        /* put */ m['Fisker'] = '5206';
        /* put */ m['B\ufffd\ufffdker og blader'] = '5209';
        /* put */ m['Oppvarming og ventilasjon'] = '5218';
        /* put */ m['Verkt\ufffd\ufffdy'] = '5219';
        /* put */ m['Dekorasjon og pyntegjenstander'] = '5222';
        /* put */ m['Kj\ufffd\ufffdkkenutstyr og serviser'] = '5223';
        /* put */ m['Modellbyggesett og modeller'] = '7732';
        /* put */ m['RC-utstyr'] = '7733';
        /* put */ m['H\ufffd\ufffdndarbeid'] = '7734';
        /* put */ m['Billetter og reiser'] = '7735';
        /* put */ m['Vannsport'] = '7738';
        /* put */ m['Smykker og oppbevaring'] = '7748';
        /* put */ m['Baderomsinnredning'] = '7749';
        /* put */ m['Sofaer og lenestoler'] = '7756';
        /* put */ m['Hud-, h\ufffd\ufffdr- og kroppspleie'] = '8280';
        /* put */ m['Kosttilskudd'] = '8281';
        /* put */ m['Kosmetikk'] = '8282';
        /* put */ m['Helse og behandling'] = '8343';
        /* put */ m['Briller og linser'] = '8344';
        /* put */ m['Hyller og kommoder'] = '8345';
        /* put */ m['Sk\ufffd\ufffdytesport'] = '8346';
        /* put */ m['Alarm og sikkerhet'] = '8347';
        /* put */ m['Garasje'] = '8348';
        /* put */ m['Kostyme'] = '8349';
        /* put */ m['Bildeler'] = '2';
        /* put */ m['Bilseter'] = '3';
        /* put */ m['Takstativ og boks'] = '4';
        /* put */ m['Bilstereo'] = '5';
        /* put */ m['Dekk og felger'] = '6';
        /* put */ m['Styling'] = '8';
        /* put */ m['Annet biltilbeh\ufffd\ufffdr'] = '9';
        /* put */ m['MC-deler'] = '10';
        /* put */ m['MC-tilbeh\ufffd\ufffdr'] = '11';
        /* put */ m['MC-kl\ufffd\ufffdr'] = '12';
        /* put */ m['Varehengere'] = '13';
        /* put */ m['B\ufffd\ufffdt- og opplagshengere'] = '14';
        /* put */ m['Skaphengere'] = '15';
        /* put */ m['ATV- og MC-hengere'] = '16';
        /* put */ m['Biltransporthengere'] = '17';
        /* put */ m['Maskinhengere'] = '18';
        /* put */ m['Hestehengere'] = '19';
        /* put */ m['Termohengere'] = '20';
        /* put */ m['Apporterende hunder'] = '21';
        /* put */ m['Blandingshunder'] = '22';
        /* put */ m['Bruks-, hyrde- og gjeterhunder'] = '23';
        /* put */ m['Dachs-, drivende og sporhunder'] = '24';
        /* put */ m['Mynder'] = '25';
        /* put */ m['Pinscher-, schnauzer-, molosser og sennenhunder'] = '26';
        /* put */ m['Selskapshunder'] = '27';
        /* put */ m['Spisshunder'] = '28';
        /* put */ m['St\ufffd\ufffdende fuglehunder'] = '29';
        /* put */ m['Terriere'] = '30';
        /* put */ m['Blandingskatter'] = '31';
        /* put */ m['Korth\ufffd\ufffdret'] = '32';
        /* put */ m['Orientalere'] = '33';
        /* put */ m['Persere'] = '34';
        /* put */ m['Semi-langh\ufffd\ufffdret'] = '35';
        /* put */ m['Kaldblodshester'] = '36';
        /* put */ m['Ponnier'] = '37';
        /* put */ m['Varmblodshester'] = '38';
        /* put */ m['Mobiltelefoner'] = '39';
        /* put */ m['Andre telefoner'] = '40';
        /* put */ m['Telefontilbeh\ufffd\ufffdr'] = '41';
        /* put */ m['B\ufffd\ufffdrbar PC'] = '43';
        /* put */ m['Stasjon\ufffd\ufffdr PC'] = '44';
        /* put */ m['Skjermer'] = '45';
        /* put */ m['Datatilbeh\ufffd\ufffdr'] = '46';
        /* put */ m['Kalkulatorer'] = '47';
        /* put */ m['Tablet og lesebrett'] = '48';
        /* put */ m['Programvare'] = '49';
        /* put */ m['MP3 og b\ufffd\ufffdrbar lyd'] = '50';
        /* put */ m['Hodetelefoner'] = '51';
        /* put */ m['Forsterkere og receivere'] = '52';
        /* put */ m['H\ufffd\ufffdyttalere'] = '53';
        /* put */ m['PA-utstyr'] = '54';
        /* put */ m['Stereo'] = '55';
        /* put */ m['Bluray-spillere'] = '56';
        /* put */ m['DVD-spillere'] = '57';
        /* put */ m['Videospillere'] = '58';
        /* put */ m['Hjemmekinoanlegg'] = '59';
        /* put */ m['Projektor og lerret'] = '60';
        /* put */ m['Digital-TV og mediabokser'] = '61';
        /* put */ m['TV'] = '62';
        /* put */ m['Spillkonsoller'] = '63';
        /* put */ m['Spill'] = '64';
        /* put */ m['Tilbeh\ufffd\ufffdr'] = '65';
        /* put */ m['Systemkameraer'] = '66';
        /* put */ m['Kompaktkameraer'] = '67';
        /* put */ m['Videokameraer'] = '68';
        /* put */ m['Objektiver'] = '69';
        /* put */ m['Fotovesker og -bager'] = '70';
        /* put */ m['Annet fotoutstyr'] = '71';
        /* put */ m['Frysere'] = '72';
        /* put */ m['Komfyrer'] = '73';
        /* put */ m['Innbyggingsovner'] = '74';
        /* put */ m['Platetopper'] = '75';
        /* put */ m['Ventilatorer'] = '76';
        /* put */ m['Mikrob\ufffd\ufffdlgeovner'] = '77';
        /* put */ m['Oppvaskmaskiner'] = '78';
        /* put */ m['Vaskemaskiner'] = '79';
        /* put */ m['T\ufffd\ufffdrketromler'] = '80';
        /* put */ m['St\ufffd\ufffdvsuger'] = '81';
        /* put */ m['Kj\ufffd\ufffdkkenmaskin og foodprosessor'] = '82';
        /* put */ m['Blender'] = '83';
        /* put */ m['Strykejern'] = '84';
        /* put */ m['Vannkoker'] = '85';
        /* put */ m['Kaffemaskin'] = '86';
        /* put */ m['Br\ufffd\ufffddrister'] = '87';
        /* put */ m['Vaffel- og toastjern'] = '88';
        /* put */ m['Miksere'] = '89';
        /* put */ m['Faglitteratur'] = '90';
        /* put */ m['Skj\ufffd\ufffdnnlitteratur'] = '91';
        /* put */ m['Blader og magasiner'] = '92';
        /* put */ m['Tegneserier'] = '93';
        /* put */ m['Kokeb\ufffd\ufffdker'] = '94';
        /* put */ m['Fakta og dokumentar'] = '95';
        /* put */ m['Oppslagsverk'] = '96';
        /* put */ m['\ufffd\ufffdvrige b\ufffd\ufffdker og verk'] = '97';
        /* put */ m['CD'] = '98';
        /* put */ m['LP/EP'] = '99';
        /* put */ m['DVD'] = '100';
        /* put */ m['VHS'] = '101';
        /* put */ m['Blu-ray'] = '102';
        /* put */ m['Trebl\ufffd\ufffdsere'] = '103';
        /* put */ m['Messinginstrumenter'] = '104';
        /* put */ m['Strykeinstrumenter'] = '105';
        /* put */ m['Andre strengeinstrumenter'] = '106';
        /* put */ m['Slagverk'] = '107';
        /* put */ m['Lydutstyr'] = '108';
        /* put */ m['Piano/flygel'] = '109';
        /* put */ m['Keyboard/synth'] = '110';
        /* put */ m['\ufffd\ufffdvrige instrumenter'] = '111';
        /* put */ m['Pakkereiser'] = '112';
        /* put */ m['Flybilletter'] = '113';
        /* put */ m['Togbilletter'] = '114';
        /* put */ m['Konsertbilletter'] = '115';
        /* put */ m['Idrettsarrangementer'] = '116';
        /* put */ m['Teaterbilletter'] = '117';
        /* put */ m['Brettspill'] = '119';
        /* put */ m['Bordspill'] = '120';
        /* put */ m['Hage- og parkspill'] = '121';
        /* put */ m['Andre spill'] = '122';
        /* put */ m['Symaskiner'] = '123';
        /* put */ m['Garn'] = '124';
        /* put */ m['Stoff'] = '125';
        /* put */ m['Sy- og strikkeutstyr'] = '126';
        /* put */ m['Vev'] = '127';
        /* put */ m['Maling og maleutstyr'] = '128';
        /* put */ m['Scrapbooking'] = '129';
        /* put */ m['Keramikk'] = '130';
        /* put */ m['Perler og smykkestener'] = '131';
        /* put */ m['Tresl\ufffd\ufffdyd'] = '132';
        /* put */ m['Bil'] = '133';
        /* put */ m['B\ufffd\ufffdt'] = '134';
        /* put */ m['Fly'] = '135';
        /* put */ m['Helikopter'] = '136';
        /* put */ m['Frimerker'] = '137';
        /* put */ m['Mynter og sedler'] = '138';
        /* put */ m['Pins'] = '139';
        /* put */ m['Postkort'] = '140';
        /* put */ m['Andre samlinger'] = '141';
        /* put */ m['Hagem\ufffd\ufffdbler'] = '142';
        /* put */ m['Hageredskap'] = '143';
        /* put */ m['Partytelt'] = '144';
        /* put */ m['Annet hageutstyr'] = '145';
        /* put */ m['Markiser og parasoller'] = '146';
        /* put */ m['Grill'] = '147';
        /* put */ m['Sn\ufffd\ufffdrydding'] = '148';
        /* put */ m['Gressklippere'] = '149';
        /* put */ m['Sv\ufffd\ufffdmmebasseng og spabad'] = '150';
        /* put */ m['Ovner'] = '151';
        /* put */ m['Peis'] = '152';
        /* put */ m['Ved og brensel'] = '153';
        /* put */ m['Varmepumper'] = '154';
        /* put */ m['Elektriske ovner'] = '155';
        /* put */ m['Blandebatterier'] = '156';
        /* put */ m['Badekar'] = '157';
        /* put */ m['Badstuer'] = '158';
        /* put */ m['Steamdusjer'] = '159';
        /* put */ m['Dusjkabinett og -vegger'] = '160';
        /* put */ m['Toaletter'] = '161';
        /* put */ m['Servanter'] = '162';
        /* put */ m['Tilbeh\ufffd\ufffdr'] = '163';
        /* put */ m['Baderomsm\ufffd\ufffdbler'] = '164';
        /* put */ m['Andre byggevarer'] = '165';
        /* put */ m['Byggesett'] = '166';
        /* put */ m['Gulv'] = '167';
        /* put */ m['Vinduer'] = '168';
        /* put */ m['D\ufffd\ufffdrer'] = '169';
        /* put */ m['Bunader'] = '170';
        /* put */ m['Brudekjoler'] = '171';
        /* put */ m['Kjoler'] = '172';
        /* put */ m['Ytterkl\ufffd\ufffdr'] = '173';
        /* put */ m['Bukser'] = '174';
        /* put */ m['Skj\ufffd\ufffdrt'] = '175';
        /* put */ m['Topper'] = '176';
        /* put */ m['Gensere'] = '177';
        /* put */ m['Jakker'] = '178';
        /* put */ m['T-skjorter'] = '179';
        /* put */ m['Skjorter'] = '180';
        /* put */ m['Undert\ufffd\ufffdy'] = '181';
        /* put */ m['Ytterkl\ufffd\ufffdr'] = '183';
        /* put */ m['Bukser'] = '184';
        /* put */ m['Skjorter'] = '185';
        /* put */ m['Gensere'] = '186';
        /* put */ m['T-skjorter'] = '187';
        /* put */ m['Bunader'] = '188';
        /* put */ m['Dresser'] = '189';
        /* put */ m['Smokinger'] = '190';
        /* put */ m['Undert\ufffd\ufffdy'] = '191';
        /* put */ m['Herresko'] = '193';
        /* put */ m['Damesko'] = '194';
        /* put */ m['Halskjeder'] = '195';
        /* put */ m['Ringer'] = '196';
        /* put */ m['\ufffd\ufffdrepynt'] = '197';
        /* put */ m['Armb\ufffd\ufffdnd'] = '198';
        /* put */ m['Solbriller'] = '199';
        /* put */ m['Briller'] = '200';
        /* put */ m['Linser'] = '201';
        /* put */ m['Senger'] = '202';
        /* put */ m['Madrasser'] = '203';
        /* put */ m['2-seter'] = '204';
        /* put */ m['3-seter'] = '205';
        /* put */ m['Sovesofaer'] = '206';
        /* put */ m['Hj\ufffd\ufffdrnesofaer'] = '207';
        /* put */ m['Sofagrupper'] = '208';
        /* put */ m['Puffer'] = '209';
        /* put */ m['Lenestoler'] = '210';
        /* put */ m['Spisestuer'] = '211';
        /* put */ m['Salongbord'] = '212';
        /* put */ m['Kj\ufffd\ufffdkkenbord'] = '213';
        /* put */ m['Skrivebord'] = '214';
        /* put */ m['Kontorstoler'] = '215';
        /* put */ m['Stoler og krakker'] = '216';
        /* put */ m['Andre bord og stoler'] = '217';
        /* put */ m['Garderober'] = '218';
        /* put */ m['Hyller'] = '219';
        /* put */ m['Skjenk'] = '220';
        /* put */ m['Kommoder'] = '221';
        /* put */ m['Seksjoner'] = '222';
        /* put */ m['Nattbord'] = '223';
        /* put */ m['TV-m\ufffd\ufffdbler'] = '224';
        /* put */ m['Skap'] = '225';
        /* put */ m['Taklamper'] = '226';
        /* put */ m['Vegglamper'] = '227';
        /* put */ m['St\ufffd\ufffdlamper'] = '228';
        /* put */ m['Bordlamper'] = '229';
        /* put */ m['Andre lamper'] = '230';
        /* put */ m['Tepper'] = '231';
        /* put */ m['Puter'] = '232';
        /* put */ m['Duker'] = '233';
        /* put */ m['Gardiner'] = '234';
        /* put */ m['Andre tekstiler'] = '235';
        /* put */ m['Bilder og rammer'] = '237';
        /* put */ m['Vaser'] = '238';
        /* put */ m['Fat'] = '239';
        /* put */ m['Lysestaker'] = '240';
        /* put */ m['Andre pyntgjenstander'] = '241';
        /* put */ m['Rekvisita'] = '242';
        /* put */ m['Kopimaskiner'] = '243';
        /* put */ m['Printere'] = '244';
        /* put */ m['Fotball'] = '245';
        /* put */ m['H\ufffd\ufffdndball'] = '246';
        /* put */ m['Basketball'] = '247';
        /* put */ m['Volleyball'] = '248';
        /* put */ m['Tennis'] = '249';
        /* put */ m['Bandy'] = '250';
        /* put */ m['Annen ballsport'] = '251';
        /* put */ m['Snowboard'] = '252';
        /* put */ m['Alpint'] = '253';
        /* put */ m['Telemark'] = '254';
        /* put */ m['Langrenn'] = '255';
        /* put */ m['Annet skiutstyr'] = '256';
        /* put */ m['Sykler'] = '257';
        /* put */ m['Utstyr'] = '258';
        /* put */ m['Dykking'] = '259';
        /* put */ m['Padling'] = '260';
        /* put */ m['Seiling'] = '261';
        /* put */ m['Surfing'] = '262';
        /* put */ m['Annet utstyr'] = '263';
        /* put */ m['Kiting'] = '264';
        /* put */ m['Klatring'] = '265';
        /* put */ m['Fallskjermhopping'] = '266';
        /* put */ m['Skate- og longboard'] = '267';
        /* put */ m['V\ufffd\ufffdpen'] = '268';
        /* put */ m['Jaktkl\ufffd\ufffdr'] = '269';
        /* put */ m['Annet jaktutstyr'] = '270';
        /* put */ m['Fiskestenger'] = '271';
        /* put */ m['Teiner og garn'] = '272';
        /* put */ m['Sneller, fluer og kroker'] = '273';
        /* put */ m['Fiskekl\ufffd\ufffdr'] = '274';
        /* put */ m['Annet fiskeutstyr'] = '275';
        /* put */ m['Soveposer'] = '276';
        /* put */ m['Telt'] = '277';
        /* put */ m['Ryggsekker'] = '278';
        /* put */ m['Kano'] = '279';
        /* put */ m['Annet turutstyr'] = '280';
        /* put */ m['Paintball'] = '281';
        /* put */ m['Pistol'] = '282';
        /* put */ m['Softgun'] = '283';
        /* put */ m['Luftv\ufffd\ufffdpen'] = '284';
        /* put */ m['Tredem\ufffd\ufffdller'] = '285';
        /* put */ m['Treningssykler'] = '286';
        /* put */ m['Romaskiner'] = '287';
        /* put */ m['Styrkeapparater'] = '288';
        /* put */ m['Treningsutstyr'] = '289';
        /* put */ m['Stepmaskiner'] = '290';
        /* put */ m['Ellipsemaskiner'] = '291';
        /* put */ m['Kj\ufffd\ufffdleskap'] = '292';
        /* put */ m['Rammemadrasser'] = '293';
        /* put */ m['Innredning'] = '294';
        /* put */ m['Gitarer'] = '295';
        /* put */ m['Bassgitarer'] = '296';
        /* put */ m['Aircondition og vifter'] = '297';
        /* put */ m['Speil'] = '299';
        /* put */ m['Kikkerter og optikk'] = '300';
        /* put */ m['Tapet og maling'] = '301';
        /* put */ m['Radio'] = '302';
        /* put */ m['Hybridkamera'] = '303';
        /* put */ m['Andre apparater'] = '304';
        /* put */ m['Andre hvitevarer'] = '305';
        /* put */ m['Andre smykker'] = '306';
        /* put */ m['Smykkeskrin og oppbevaring'] = '307';
        /* put */ m['Tilhengertilbeh\ufffd\ufffdr'] = '308';
        /* put */ m['Tipphengere'] = '309';
        /* put */ m['Luer, skjerf og votter'] = '310';
        /* put */ m['Luer, skjerf og votter'] = '311';
        /* put */ m['Senger'] = '312';
        /* put */ m['Stoler'] = '313';
        /* put */ m['Bord'] = '314';
        /* put */ m['Oppbevaring'] = '315';
        /* put */ m['Stellebord'] = '316';
        /* put */ m['Elektronikk'] = '318';
        /* put */ m['Str\ufffd\ufffdm og VVS'] = '319';
        /* put */ m['Interi\ufffd\ufffdr og eksteri\ufffd\ufffdr'] = '320';
        /* put */ m['Styring og vinsj'] = '321';
        /* put */ m['Sikkerhet'] = '322';
        /* put */ m['Seilb\ufffd\ufffdtutstyr'] = '323';
        /* put */ m['Fort\ufffd\ufffdyningsutstyr'] = '324';
        /* put */ m['Annet b\ufffd\ufffdtutstyr'] = '325';
        /* put */ m['Kabler og tilbeh\ufffd\ufffdr'] = '326';
        /* put */ m['Modelljernbaner'] = '327';
        /* put */ m['Trekkspill'] = '328';
        /* put */ m['Puslespill'] = '329';
        /* put */ m['Babyleker'] = '330';
        /* put */ m['Bamser, dukker og figurer'] = '331';
        /* put */ m['Biler og baner'] = '332';
        /* put */ m['Lego og byggeklosser'] = '333';
        /* put */ m['Tegne- og formingsutstyr'] = '334';
        /* put */ m['Uteleker'] = '335';
        /* put */ m['Andre leker'] = '336';
        /* put */ m['Orgler'] = '337';
        /* put */ m['Windsurf'] = '338';
        /* put */ m['Beplantning og tilbeh\ufffd\ufffdr'] = '339';
        /* put */ m['Motordeler'] = '340';
        /* put */ m['Baby'] = '341';
        /* put */ m['Gutt'] = '342';
        /* put */ m['Jente'] = '343';
        /* put */ m['GPS'] = '344';
        /* put */ m['Navigasjon'] = '345';
        /* put */ m['Trapper'] = '346';
        /* put */ m['F\ufffd\ufffdrstehjelpsutstyr'] = '347';
        /* put */ m['Hjelpemidler'] = '348';
        /* put */ m['Hud- og kroppspleie'] = '349';
        /* put */ m['Utstyr og inventar'] = '350';
        /* put */ m['Kj\ufffd\ufffdkkenutstyr'] = '351';
        /* put */ m['Kj\ufffd\ufffdl og frys'] = '352';
        /* put */ m['Koke- og stekeprodukter'] = '353';
        /* put */ m['Oppvask'] = '354';
        /* put */ m['Innredning'] = '355';
        /* put */ m['Annet utstyr'] = '356';
        /* put */ m['Annet utstyr'] = '357';
        /* put */ m['Betalingsutstyr'] = '358';
        /* put */ m['Butikkinnredning'] = '359';
        /* put */ m['Sikkerhet og overv\ufffd\ufffdkning'] = '360';
        /* put */ m['Lagerutstyr'] = '361';
        /* put */ m['Butikkbelysning'] = '362';
        /* put */ m['Vareparti og konkursbo'] = '363';
        /* put */ m['Annet butikkutstyr'] = '364';
        /* put */ m['Containere'] = '365';
        /* put */ m['Brakker'] = '366';
        /* put */ m['Mannskapsvogner'] = '367';
        /* put */ m['Annet anleggsutstyr'] = '368';
        /* put */ m['Verkt\ufffd\ufffdy'] = '369';
        /* put */ m['Verkstedsutstyr'] = '370';
        /* put */ m['Lys'] = '371';
        /* put */ m['Byggt\ufffd\ufffdrkere'] = '372';
        /* put */ m['Kompressor'] = '373';
        /* put */ m['Stillas og reoler'] = '374';
        /* put */ m['Treforedling'] = '375';
        /* put */ m['Maskinutleie'] = '376';
        /* put */ m['Maskiner og utstyr'] = '377';
        /* put */ m['Lagerhall'] = '378';
        /* put */ m['Annet utstyr'] = '379';
        /* put */ m['Unisex'] = '380';
        /* put */ m['Baby'] = '381';
        /* put */ m['Gutt'] = '382';
        /* put */ m['Jente'] = '383';
        /* put */ m['Unisex'] = '384';
        /* put */ m['Akryl'] = '385';
        /* put */ m['Akvarell'] = '386';
        /* put */ m['Blandingsteknikker'] = '387';
        /* put */ m['Fotografi'] = '388';
        /* put */ m['Litografi'] = '389';
        /* put */ m['Oljemaleri'] = '390';
        /* put */ m['Skulptur'] = '391';
        /* put */ m['Tegning'] = '392';
        /* put */ m['Tresnitt'] = '393';
        /* put */ m['Trykk'] = '394';
        /* put */ m['Annen kunst'] = '395';
        /* put */ m['Samlekort'] = '396';
        /* put */ m['Milit\ufffd\ufffdreffekter'] = '397';
        /* put */ m['Skilt og plakater'] = '398';
        /* put */ m['Leker'] = '399';
        /* put */ m['Samlefigurer'] = '400';
        /* put */ m['Drone'] = '401';
        /* put */ m['Kassetter'] = '402';
        /* put */ m['Havplast'] = '403';
        /* put */ m['Sk\ufffd\ufffdyter til voksne'] = '404';
        /* put */ m['Sk\ufffd\ufffdyter til barn'] = '405';
        /* put */ m['Sk\ufffd\ufffdyteutstyr'] = '406';
        /* put */ m['Herrekl\ufffd\ufffdr'] = '3980';
        /* put */ m['Damekl\ufffd\ufffdr'] = '3981';
        /* put */ m['Unisex'] = '3982';
        /* put */ m['Barnekl\ufffd\ufffdr'] = '3983';
        /* put */ m['Sko'] = '3984';
        TypeTransformationUtils.valueIdMap = new Map(Object.entries(m));
        TypeTransformationUtils.conversionMap = {};
    }
    static convertTo2DList(value) {
        if (/* isEmpty */ value.length === 0) {
            throw Object.defineProperty(
                new Error('No size parameter found'),
                '__classes',
                {
                    configurable: true,
                    value: [
                        'java.lang.Throwable',
                        'java.lang.Object',
                        'java.lang.Exception',
                    ],
                },
            );
        }
        let sizes = [];
        let sizesAsStrings = value
            .split(TypeTransformationUtils.SEMICOLON)
            .slice(0);
        for (
            let index11207 = 0;
            index11207 < sizesAsStrings.length;
            index11207++
        ) {
            let size = sizesAsStrings[index11207];
            {
                let sizesAsInts = [];
                let tmpSizes = size
                    .split(TypeTransformationUtils.COMMA)
                    .slice(0);
                for (
                    let index11208 = 0;
                    index11208 < tmpSizes.length;
                    index11208++
                ) {
                    let tmp = tmpSizes[index11208];
                    {
                        /* add */ sizesAsInts.push(
                            /* parseInt */ parseInt(tmp),
                        ) > 0;
                    }
                }
                if (/* size */ sizesAsInts.length !== 2) {
                    throw Object.defineProperty(
                        new Error(
                            'Each size must have exactly two numbers (x+y)',
                        ),
                        '__classes',
                        {
                            configurable: true,
                            value: [
                                'java.lang.Throwable',
                                'java.lang.Object',
                                'java.lang.Exception',
                            ],
                        },
                    );
                }
                /* add */ sizes.push(sizesAsInts) > 0;
            }
        }
        return sizes;
    }
    static convertToList(value) {
        let formats = [];
        /* add */ formats.push(TypeTransformationUtils.BANNER) > 0;
        if (!(value.length === 0)) {
            let tmpFormats = value
                .split(TypeTransformationUtils.COMMA)
                .slice(0);
            for (
                let index11209 = 0;
                index11209 < tmpFormats.length;
                index11209++
            ) {
                let tmp = tmpFormats[index11209];
                {
                    /* add */ formats.push(tmp) > 0;
                }
            }
        }
        return formats;
    }
    static listToDelimitedString(list, delimiter, deleteLastDelimiter) {
        let delimitedString = {
            str: '',
            toString: function () {
                return this.str;
            },
        };
        if (!(list.length === 0)) {
            for (let index11210 = 0; index11210 < list.length; index11210++) {
                let item = list[index11210];
                {
                    /* append */ ((sb) => {
                        sb.str = sb.str.concat(item);
                        return sb;
                    })(delimitedString);
                    /* append */ ((sb) => {
                        sb.str = sb.str.concat(delimiter);
                        return sb;
                    })(delimitedString);
                }
            }
            if (deleteLastDelimiter) {
                /* deleteCharAt */ ((sb, index) => {
                    sb.str = sb.str.substr(0, index) + sb.str.substr(index + 1);
                    return sb;
                })(
                    delimitedString,
                    /* length */ delimitedString.str.length - 1,
                );
            }
        }
        return delimitedString;
    }
    static generatePlainMap(config, pageContext, rules, isKeyword) {
        if (/* isEmpty */ Object.keys(config).length === 0) {
            return {};
        }
        return TypeTransformationUtils.modifyElement(
            config,
            pageContext,
            rules,
            true,
            isKeyword,
        );
    }
    /**
     * @param {*} config      map of targeting parameters from the config that can be found on a page
     * @param {*} pageContext actual parameter values on the page
     * @param {*} rules       all rules that belongs to a page
     * @return {string[]} a list of targeting strings ready to be inserted into the banner url
     */
    static generateList(config, pageContext, rules) {
        let completeList = [];
        let modifiedPageContext;
        if (/* isEmpty */ Object.keys(config).length === 0) {
            return completeList;
        }
        modifiedPageContext = TypeTransformationUtils.modifyElement(
            config,
            pageContext,
            rules,
            false,
            false,
        );
        {
            let array11212 = /* keySet */ Object.keys(modifiedPageContext);
            for (
                let index11211 = 0;
                index11211 < array11212.length;
                index11211++
            ) {
                let key = array11212[index11211];
                {
                    /* add */ completeList.push(
                        /* get */ ((m, k) =>
                            m[k] === undefined ? null : m[k])(
                            modifiedPageContext,
                            key,
                        ),
                    ) > 0;
                }
            }
        }
        return completeList;
    }
    static modifyElement(
        config,
        pageContext,
        rules,
        isPlainElement,
        isKeyword,
    ) {
        let modifiedPageContext = {};
        {
            let array11214 = /* keySet */ Object.keys(pageContext);
            for (
                let index11213 = 0;
                index11213 < array11214.length;
                index11213++
            ) {
                let element = array11214[index11213];
                {
                    if (/* containsKey */ config.hasOwnProperty(element)) {
                        let modifiedElement;
                        let configParameter = ((m, k) =>
                            m[k] === undefined ? null : m[k])(config, element);
                        if (/* containsKey */ rules.hasOwnProperty(element)) {
                            modifiedElement =
                                TypeTransformationUtils.applyRuleToElement(
                                    /* get */ ((m, k) =>
                                        m[k] === undefined ? null : m[k])(
                                        rules,
                                        element,
                                    ),
                                    /* get */ ((m, k) =>
                                        m[k] === undefined ? null : m[k])(
                                        pageContext,
                                        element,
                                    ),
                                    isKeyword,
                                );
                        } else {
                            const arr = /* get */ /* get */ ((m, k) =>
                                m[k] === undefined ? null : m[k])(
                                pageContext,
                                element,
                            );
                            modifiedElement = arr[arr.length - 1];
                        }
                        if (isPlainElement) {
                            /* put */ modifiedPageContext[
                                TypeTransformationUtils.removeChar(
                                    configParameter,
                                    '=',
                                )
                            ] = modifiedElement;
                        } else {
                            /* put */ modifiedPageContext[element] =
                                TypeTransformationUtils.addPrefixAndEncode(
                                    configParameter,
                                    modifiedElement,
                                );
                        }
                    }
                }
            }
        }
        return modifiedPageContext;
    }
    static removeChar(element, character) {
        return /* replace */ element.split(character).join('');
    }
    static applyRuleToElement(rules, elements, isKeyword) {
        let returnValue = Array.isArray(elements) ? elements[0] : elements;
        {
            let array11216 = /* keySet */ Object.keys(rules);
            for (
                let index11215 = 0;
                index11215 < array11216.length;
                index11215++
            ) {
                let key = array11216[index11215];
                {
                    let rule = key;
                    switch (rule) {
                        case TypeTransformationUtils.ENCODESPECCHAR:
                            returnValue =
                                TypeTransformationUtils.ruleEncodeSpecialCharacters(
                                    returnValue,
                                );
                            break;
                        case TypeTransformationUtils.PREFIX:
                            returnValue = TypeTransformationUtils.rulePrefix(
                                /* get */ ((m, k) =>
                                    m[k] === undefined ? null : m[k])(
                                    rules,
                                    key,
                                ),
                                returnValue,
                            );
                            break;
                        case TypeTransformationUtils.CONVERTTOID:
                            if (isKeyword) {
                                returnValue =
                                    TypeTransformationUtils.getMappedId(
                                        returnValue,
                                    );
                            }
                            break;
                        case TypeTransformationUtils.CONVERTTOVALUE:
                            if (!isKeyword) {
                                returnValue =
                                    TypeTransformationUtils.ruleConvertToValue(
                                        returnValue,
                                    );
                            }
                            break;
                        default:
                            break;
                    }
                }
            }
        }
        return returnValue;
    }
    static addPrefixAndEncode(prefix, value) {
        let returnValue = {
            str: '',
            toString: function () {
                return this.str;
            },
        };
        /* append */ ((sb) => {
            sb.str = sb.str.concat(prefix);
            return sb;
        })(returnValue);
        /* append */ ((sb) => {
            sb.str = sb.str.concat(value);
            return sb;
        })(returnValue);
        return /* toString */ returnValue.str;
    }
    static rulePrefix(prefix, parameterValue) {
        return prefix + parameterValue;
    }
    static ruleEncodeSpecialCharacters(parameterValue) {
        return TypeTransformationUtils.replaceSpecialCharacters(parameterValue);
    }
    static ruleConvertToId(value) {
        return TypeTransformationUtils.getIdForValue(value);
    }
    static ruleConvertToValue(id) {
        return TypeTransformationUtils.getValueForId(id);
    }
    static isEmpty(str) {
        return str == null || str.length === 0;
    }
    static replaceSpecialCharacters(str) {
        if (TypeTransformationUtils.isEmpty(str)) {
            return str;
        }
        str =
            /* replaceAll */ /* replaceAll */ /* replaceAll */ /* replaceAll */ /* replaceAll */ /* replaceAll */ /* replaceAll */ /* replaceAll */ /* replaceAll */ /* replaceAll */ /* replaceAll */ /* replaceAll */ /* replaceAll */ /* replaceAll */ /* replaceAll */ /* replaceAll */ /* replaceAll */ /* replaceAll */ /* replaceAll */ /* replaceAll */ /* replaceAll */ /* replaceAll */ /* replaceAll */ /* replaceAll */ str
                .replace(new RegExp(' ', 'g'), '_')
                .replace(new RegExp('\\=', 'g'), '_')
                .replace(new RegExp('\\!', 'g'), '_')
                .replace(new RegExp('\\+', 'g'), '_')
                .replace(new RegExp('#', 'g'), '_')
                .replace(new RegExp('\\*', 'g'), '_')
                .replace(new RegExp('\\~', 'g'), '_')
                .replace(new RegExp(';', 'g'), '_')
                .replace(new RegExp('\\^', 'g'), '_')
                .replace(new RegExp('\\(', 'g'), '_')
                .replace(new RegExp('\\)', 'g'), '_')
                .replace(new RegExp('\\<', 'g'), '_')
                .replace(new RegExp('\\>', 'g'), '_')
                .replace(new RegExp('\\[', 'g'), '_')
                .replace(new RegExp('\\]', 'g'), '_')
                .replace(new RegExp(',', 'g'), '_')
                .replace(new RegExp('&', 'g'), '_')
                .replace(new RegExp('@', 'g'), '_')
                .replace(new RegExp(':', 'g'), '_')
                .replace(new RegExp('\\?', 'g'), '_')
                .replace(new RegExp('%', 'g'), '_')
                .replace(new RegExp('/', 'g'), '_')
                .replace(new RegExp("'", 'g'), '')
                .replace(new RegExp('"', 'g'), '');
        return str;
    }
    static getMappedId(value) {
        if (
            /* containsKey */ TypeTransformationUtils.valueIdMap_$LI$().hasOwnProperty(
                value,
            )
        ) {
            return /* get */ ((m, k) => (m[k] === undefined ? null : m[k]))(
                TypeTransformationUtils.valueIdMap_$LI$(),
                value,
            );
        }
        return '';
    }
    static getIdForValue(value) {
        if (
            !(
                Object.keys(TypeTransformationUtils.conversionMap_$LI$())
                    .length === 0
            )
        ) {
            if (
                /* containsKey */ TypeTransformationUtils.conversionMap_$LI$().hasOwnProperty(
                    value,
                )
            ) {
                return /* get */ ((m, k) => (m[k] === undefined ? null : m[k]))(
                    TypeTransformationUtils.conversionMap_$LI$(),
                    value,
                );
            }
        }
        return '';
    }
    static getValueForId(id) {
        if (
            !(
                Object.keys(TypeTransformationUtils.conversionMap_$LI$())
                    .length === 0
            )
        ) {
            {
                let array11218 = /* entrySet */ ((o) => {
                    let s = [];
                    for (let e in o)
                        s.push({
                            k: e,
                            v: o[e],
                            getKey: function () {
                                return this.k;
                            },
                            getValue: function () {
                                return this.v;
                            },
                        });
                    return s;
                })(TypeTransformationUtils.conversionMap_$LI$());
                for (
                    let index11217 = 0;
                    index11217 < array11218.length;
                    index11217++
                ) {
                    let entry = array11218[index11217];
                    {
                        if (
                            /* equals */ ((o1, o2) => {
                                if (o1 && o1.equals) {
                                    return o1.equals(o2);
                                } else {
                                    return o1 === o2;
                                }
                            })(entry.getValue(), id)
                        ) {
                            return entry.getKey();
                        }
                    }
                }
            }
        }
        return '';
    }
}
TypeTransformationUtils.ENCODESPECCHAR = 'encodeSpecChar';
TypeTransformationUtils.PREFIX = 'prefix';
TypeTransformationUtils.CONVERTTOID = 'convertToId';
TypeTransformationUtils.CONVERTTOVALUE = 'convertToValue';
TypeTransformationUtils.__static_initialized = false;
TypeTransformationUtils.COMMA = ',';
TypeTransformationUtils.SEMICOLON = ';';
TypeTransformationUtils.BANNER = 'banner';
